import React, { useState, useEffect } from "react";
import { GetData, PostData } from "../../services/api";
import DataTable from "react-data-table-component";
import moment from "moment"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  UncontrolledDropdown,
  Container,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Col,
  Button,
  Label,
  FormGroup
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Loader from "../../components/Common/Loader";
import Swal from 'sweetalert2'
import ReactPaginate from 'react-paginate';
import IntegrationModal from "./IntegrationModal";

const ContactLists = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [listType, setListType] = useState("static");
  const [integrationModal, setIntegrationModal] = useState({ open: false, listId: null, listName: "" });

  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 10
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = data.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  const fetchData = async () => {
    const { data } = await GetData("/contact-lists");
    const ordered = data.sort((a, b) => { return new Date(b.createdAt) - new Date(a.createdAt) });
    setData(ordered);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nombre</span>,
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Tipo</span>,
      selector: (row) => row.type === 'dynamic' ? 'Dinámica' : 'Estática',
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Compañia</span>,
      selector: (row) => row.company?.name || '-',
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Contactos</span>,
      selector: (row) => row.count || '0',
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Creada</span>,
      selector: (row) => row.createdAt ? moment(row.createdAt).format("DD/MM/YYYY HH:mm") : "-",
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Acción</span>,
      sortable: true,
      cell: (data) => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-soft-secondary btn-sm"
              tag="button"
            >
              <i className="ri-more-fill align-middle"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem>
                <Link to={`/contact-lists/${data.id}`} className="text-muted">
                  <i className="ri-eye-fill align-bottom me-2 text-muted"></i>
                  Ver Contactos
                </Link>
              </DropdownItem>
              <DropdownItem onClick={() => setIntegrationModal({ open: true, listId: data.id, listName: data.name })}>
                <i className="mdi mdi-api align-bottom me-2 text-muted"></i>
                Integración
              </DropdownItem>
              <DropdownItem className="edit-item-btn">
                <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                Editar
              </DropdownItem>
              {data.type === 'dynamic' && (
                <DropdownItem>
                  <Link to={`/contact-lists/${data.id}/rules`} className="text-muted">
                    <i className="ri-settings-3-line align-bottom me-2 text-muted"></i>
                    Reglas
                  </Link>
                </DropdownItem>
              )}
              <DropdownItem className="remove-item-btn" onClick={() => deleteList(data.id)}>
                <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                Eliminar
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  const createList = async () => {
    try {
      const { status } = await PostData("/contact-lists", { 
        name,
        type: listType
      })
      if (status === 200) {
        Swal.fire({
          title: `Lista "${name}" creada`,
          icon: "success"
        });
        fetchData()
        setModal(false)
        setName("")
        setListType("static")
      }
    } catch (err) {
      console.log(err)
      Swal.fire({
        title: "Error",
        text: err.message || "Error al crear la lista",
        icon: "error"
      });
    }
  }

  const deleteList = (id) => {
    Swal.fire({
      title: "¿Deseas eliminar la lista?",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: '#dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        // TODO: Implement delete API call
        Swal.fire("Lista eliminada!", "", "success");
        fetchData();
      }
    });
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title="IHubG" breadcrumbItem="Listas de Contactos" />
        <Row className="my-4">
          <Col className="col-sm-auto">
            <div className="d-flex gap-1 justify-content-end">
              <Button
                color="success"
                className="add-btn"
                onClick={() => {
                  setModal(true);
                }}
                id="create-btn"
              >
                <i className="ri-add-line align-bottom me-1"></i> Nueva Lista
              </Button>
            </div>
          </Col>
        </Row>
        <Row className="mb-4">
          {loading ? (
            <Loader size={150} />
          ) : (
            <>
              <DataTable
                data={currentItems}
                columns={columns}
                noDataComponent={<span className="py-4">Sin resultados</span>}
              />
              <ReactPaginate
                breakLabel="..."
                nextLabel="Sig. >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={10}
                pageCount={pageCount}
                previousLabel="< Ant."
                renderOnZeroPageCount={null}
                className='reactPaginate'
                activeClassName="reactPaginate-active"
              />
            </>
          )}
        </Row>
      </Container>
      <IntegrationModal
        isOpen={integrationModal.open}
        toggle={() => setIntegrationModal({ open: false, listId: null, listName: "" })}
        listId={integrationModal.listId}
        listName={integrationModal.listName}
      />

      <Modal
        isOpen={modal}
        centered
        toggle={() => setModal(false)}
      >
        <ModalHeader
          className="bg-light p-3"
          id="exampleModalLabel"
        >
          Nueva Lista de Contactos
        </ModalHeader>
        <div className="tablelist-form">
          <ModalBody style={{ height: "auto" }}>
            <div className="mb-3">
              <label htmlFor="name-field" className="form-label">
                Nombre
              </label>
              <input
                type="text"
                id="name-field"
                className="form-control"
                placeholder="Ingresa un nombre para la lista"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <FormGroup>
              <Label>Tipo de Lista</Label>
              <div className="mt-2">
                <FormGroup check className="form-check-inline">
                  <Input
                    type="radio"
                    name="listType"
                    id="static"
                    value="static"
                    checked={listType === "static"}
                    onChange={(e) => setListType(e.target.value)}
                  />
                  <Label check htmlFor="static">
                    Estática (contactos agregados manualmente)
                  </Label>
                </FormGroup>
                <FormGroup check className="form-check-inline ms-3">
                  <Input
                    type="radio"
                    name="listType"
                    id="dynamic"
                    value="dynamic"
                    checked={listType === "dynamic"}
                    onChange={(e) => setListType(e.target.value)}
                  />
                  <Label check htmlFor="dynamic">
                    Dinámica (basada en reglas)
                  </Label>
                </FormGroup>
              </div>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <div className="">
              <button
                type="button"
                className="btn btn-light mx-4"
                onClick={() => {
                  setModal(false);
                  setName("");
                  setListType("static");
                }}
              >
                Cerrar
              </button>
              <button
                onClick={createList}
                className="btn btn-success"
                id="add-btn"
                disabled={!name.trim()}
              >
                Crear
              </button>
            </div>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};

export default ContactLists;

